import { Injectable } from '@angular/core';
import { UserLoginRole } from 'src/app/enumeration/roles'; // Import your roles enum

// 1. Strongly typed link schema
export interface SidebarLink {
  link: string;
  name: string;
  icon: string;
  allowedRoles: string[]; // Access control metadata
}

@Injectable({
  providedIn: 'root' // Automatically makes the service available system-wide
})
export class RouteLinksByRolesService {

  // 2. Single Master List of Links (No more duplicated arrays!)
  private readonly masterLinks: SidebarLink[] = [
    {
      link: '/nav/home',
      name: 'Home',
      icon: 'bi-speedometer2', // Premium modern icon
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN, UserLoginRole.LUCKY_DRAW_ADMIN, UserLoginRole.REDEEM_PAYMENT_ADMIN, UserLoginRole.AUDIT_ADMIN, UserLoginRole.LMS_ADMIN]
    },
    {
      link: '/nav/admin-list',
      name: 'Admin',
      icon: 'bi-shield-lock',
      allowedRoles: [UserLoginRole.SUPER_ADMIN]
    },
    {
      link: '/nav/qr-code-list',
      name: 'QR Code',
      icon: 'bi-qr-code',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN, UserLoginRole.LUCKY_DRAW_ADMIN, UserLoginRole.AUDIT_ADMIN]
    },
    {
      link: '/nav/qr-upload',
      name: 'QR Upload',
      icon: 'bi-cloud-arrow-up',
      allowedRoles: [UserLoginRole.SUPER_ADMIN]
    },
    {
      link: '/nav/lucky-draw-list',
      name: 'Lucky Draw',
      icon: 'bi-stars',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.LUCKY_DRAW_ADMIN]
    },
    {
      link: '/nav/redeem-item-list',
      name: 'Exchange',
      icon: 'bi-bag-check',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN]
    },
    {
      link: '/nav/customer-redeem-list/0',
      name: 'Redeem',
      icon: 'bi-gift-fill',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN, UserLoginRole.REDEEM_PAYMENT_ADMIN]
    },
    {
      link: '/nav/transaction-list',
      name: 'Transaction',
      icon: 'bi-receipt',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN]
    },
    {
      link: '/nav/customer-list',
      name: 'Customer',
      icon: 'bi-people-fill',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN]
    },
    {
      link: '/nav/block-phone-list',
      name: 'Block Phone',
      icon: 'bi-telephone-x',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN]
    },
    {
      link: '/nav/lms-course-item-list',
      name: 'LMS Course Items',
      icon: 'bi-journal-bookmark',
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN, UserLoginRole.LMS_ADMIN]
    },
    {
      link: '/nav/lms-coupon-code-list',
      name: 'LMS Coupons',
      icon: 'bi-tags', 
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN , UserLoginRole.LMS_ADMIN]
    },
    {
      link: '/nav/lms-course-redeem-list',
      name: 'LMS Course Redeems',
      icon: 'bi-gift', 
      allowedRoles: [UserLoginRole.SUPER_ADMIN, UserLoginRole.ADMIN , UserLoginRole.LMS_ADMIN]
    }

  ];

  /**
 * Automatically filters master links based on single or multiple user roles.
 * @param currentRoles Can be a single string 'ADMIN' or an array ['ADMIN', 'AUDIT_ADMIN']
 */
  getLinksForRole(currentRoles: string | string[]): SidebarLink[] {
    if (!currentRoles) return [];

    // Normalize input into a clean, uppercase array of strings regardless of format
    const userRolesArray = Array.isArray(currentRoles)
      ? currentRoles.map(role => role.toUpperCase())
      : [currentRoles.toUpperCase()];

    // Filter the list: Allow the link if the user has AT LEAST ONE matching role
    return this.masterLinks.filter(link => {
      const allowedUpper = link.allowedRoles.map(r => r.toUpperCase());

      // .some() returns true if any item in userRolesArray exists inside allowedUpper
      return userRolesArray.some(role => allowedUpper.includes(role));
    });
  }

}
